import React from 'react';
import Swal from 'sweetalert2';
import * as XLSX from 'xlsx';
import Viewmore_table from './Viewmore_table';

const Stafftable = () => {

    // Handle delete action
    const handleDelete = () => {
        Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, delete it!",
        }).then((result) => {
            if (result.isConfirmed) {
                // Simulate deletion (you can replace this with actual deletion logic)
                Swal.fire("Deleted!", "The lead has been deleted.", "success");
                // Actual deletion logic should go here
                console.log("Lead deleted");
            }
        });
    };

    // Export table data to Excel
    const exportToExcel = () => {
        const table = document.getElementById('realdolead'); // Get the table by ID
        const wb = XLSX.utils.table_to_book(table, { sheet: "Sheet1" }); // Convert table to workbook
        XLSX.writeFile(wb, 'leads.xlsx'); // Export the workbook as an Excel file
    };

    return (
        <div>
            {/* Add New and Export Buttons */}
            <div className="d-flex justify-content-between mb-3">
                <button 
                    type="button" 
                    className="btn btn-success" 
                    data-bs-toggle="modal" 
                    data-bs-target="#AddstaffModal">
                    Add New
                </button>
                <button 
                    type="button" 
                    className="btn btn-info text-white" 
                    onClick={exportToExcel}>
                    Export
                </button>
            </div>

            {/* Table with data */}
           <div className="table-responsive">
           <table id="realdolead" className="table table-striped w-100">
                <thead>
                    <tr>
                        <th>Sr no</th>
                        <th>Name</th>
                        <th>User Name</th>
                        <th>Access Project</th>
                        <th>Status</th>
                        <th>Profile Image</th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>1</td>
                        <td>Tiger Nixon</td>
                        <td>1234567890</td>
                        <td>Stage 1</td>
                        <td>2024-12-12</td>
                        <td>2024-12-12</td>
                        <td>
                            <i className="fas fa-eye text-white bg-primary p-2 rounded-sm view-more-icon" 
                                title="View More" 
                                data-bs-toggle="modal" 
                                data-bs-target="#ViewstaffModal"
                                data-id="1" 
                                data-name="Tiger Nixon" 
                                data-number="1234567890"
                                data-stage="Stage 1" 
                                data-followup="2024-12-12"></i>
                            <i className="fas fa-edit text-black ms-3 bg-warning p-2"   
                                data-bs-toggle="modal" 
                                data-bs-target="#EditstaffModal" 
                                title="Edit"></i>
                            <i className="fas fa-trash text-white ms-3 bg-danger p-2" 
                                title="Delete" 
                                onClick={handleDelete} 
                                id="delete-icon"></i>
                        </td>
                    </tr>
                </tbody>
            </table>
           </div>

            {/* Add New Lead Modal */}
            <Viewmore_table />
        </div>
    );
}

export default Stafftable;
